import { AxiosError } from "axios";

import {
  ResponseWithErrors,
  ResponseWithMessage,
} from "@src/modules/shared/types";

export const getErrorMessageFromResponse = (
  error: AxiosError<ResponseWithMessage & ResponseWithErrors>,
) => {
  let errorMessage;
  const fieldsErrors = error.response?.data?.errors;

  if (fieldsErrors) {
    const firstFieldErrors = Object.values(fieldsErrors).find(() => true);
    if (firstFieldErrors) {
      errorMessage = firstFieldErrors.find(() => true);
    }
  }

  const data = error.response?.data;
  let message = errorMessage;
  if (Array.isArray(data) && data.length) {
    message = data.map((e) => e.message).join(", ");
  } else if (data?.message) message = data.message;

  return message;
};
